import { Editor, Transforms } from 'slate';
import { DividerElement } from './custom-types';
import { useSlateStatic } from 'slate-react';
import { LucideMinus } from 'lucide-react';

export function DividerButton() {
  const editor = useSlateStatic();
  return (
    <button
      type="button"
      className="btn btn-xs"
      onMouseDown={(event) => {
        event.preventDefault();
        insertDivider(editor);
      }}
      tabIndex={-1}
    >
      <LucideMinus />
    </button>
  );
}

const insertDivider = (editor: Editor) => {
  const text = { text: '' };
  const divider: DividerElement = { type: 'divider', children: [text] };
  Transforms.insertNodes(editor, divider);
  Transforms.insertNodes(editor, {
    type: 'paragraph',
    children: [{ text: '' }],
  });
};
